import type {SimpleProductType} from 'constants/flow/flowTypesProduct';

import type {OptionType, EecProductType} from 'libs/EEC/productToEECProductType';
import {emptyByDefault, getProductType} from 'libs/EEC/productToEECProduct';
import {prepareBaseImpressionData} from 'libs/EEC/convertData/prepareData';
import {getRegularPrice} from 'libs/EEC/getPrice';

/**
 * Convert product to EEC product
 * @param {Array<SimpleProductType>} products - Products list
 * @param {OptionType} options - Options
 * @param {{list: string}} props - Options
 * @returns {EecProductType} - EEC products
 */
export const productToEECProduct = (
    products: Array<SimpleProductType>,
    options: OptionType = {},
    props?: {list: string},
): Array<EecProductType> => {
    const {index: startIndex = 1} = options;
    return products.map((product: SimpleProductType, index: number): EecProductType => ({
        ...prepareBaseImpressionData(product, options),
        brand: emptyByDefault(product.brand_value || product?.brand?.label || product?.brand),
        position: index + startIndex,
        list: props && props.list ? props.list : product.list,
        dimension36: getRegularPrice(product),
        dimension60: getProductType(product.type || options.type),
    }));
};
